import { render, staticRenderFns } from "./TsFieldSelect.vue?vue&type=template&id=ec863a32"
import script from "./TsFieldSelect.vue?vue&type=script&lang=ts"
export * from "./TsFieldSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports